// extracted by mini-css-extract-plugin
export var indeterminate = "_3z-5";
export var md = "_3z-4";
export var semantic = "_3z-6";
export var sm = "_3z-3";
export var text = "_3z-7";
export var toggleInput = "_3z-0";
export var toggleSwitch = "_3z-1";
export var xs = "_3z-2";